import {Button, Drawer} from '@material-ui/core';
import {Empty, isLoaded} from 'Core/models/Async';
import {CorrespondenceLetter, mapCorrespondenceLetter} from 'Agent/Policies/api/apiTypes';
import AddressChangeForOwnerLetter from 'Agent/Policies/components/Correspondence/AddressChangeForOwner';
import AutomaticPremiumLoanProvision from 'Agent/Policies/components/Correspondence/AutomaticPremiumLoanProvision';
import FuturePurchaseOptions from 'Agent/Policies/components/Correspondence/FuturePurchaseOptions';
import GraceAFLetter from 'Agent/Policies/components/Correspondence/GraceAFNotice';
import GraceLetter from 'Agent/Policies/components/Correspondence/GraceNotice';
import InitialPremiumNotReceived from 'Agent/Policies/components/Correspondence/InitialPremiumNotReceived';
import LoanPaidInFull from 'Agent/Policies/components/Correspondence/LoanPaidInFull';
import PolicyLapse from 'Agent/Policies/components/Correspondence/PolicyLapse';
import PolicyLapseA from 'Agent/Policies/components/Correspondence/PolicyLapseA';
import PolicyPreLapse from 'Agent/Policies/components/Correspondence/PolicyPreLapse';
import PremiumChangeDueToExpiryOfSupplementalBenefit from 'Agent/Policies/components/Correspondence/PremiumChangeDueToExpiryOfSupplementalBenefit';
import PremiumNoticeLetter from 'Agent/Policies/components/Correspondence/PremiumNotice';
import PremiumPaidUp from 'Agent/Policies/components/Correspondence/PremiumPaidUp';
import RenewableTermPremiumChange from 'Agent/Policies/components/Correspondence/RenewableTermPolicyPremiumChange';
import RequestToCancel from 'Agent/Policies/components/Correspondence/RequestToCancel';
import ReturnedPaymentLetter from 'Agent/Policies/components/Correspondence/ReturnedPayment';
import WitholdingFromLoanLetter from 'Agent/Policies/components/Correspondence/WitholdingFromLoanOrPatialWithdrawls';
import 'Agent/Policies/components/CorrespondenceDetails.sass';
import {changeCorrespondenceDetails} from 'Agent/Policies/ducks/policyCorrespondence';
import React, {ReactNode} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import notEmpty from 'Shared/utilities/notEmpty';

const CorrespondenceDetails = () => {
  const dispatch = useDispatch();
  const {correspondenceDetails} = useSelector((state: ReducerState) => state.policyCorrespondence);
  const onCloseDetails = () => dispatch(changeCorrespondenceDetails(new Empty()));

  return (
    <Drawer anchor="right" onClose={onCloseDetails} open={isLoaded(correspondenceDetails)}>
      <div className="correspondence-details">
        {isLoaded(correspondenceDetails) &&
          correspondenceDetails.Data.map(mapCorrespondenceLetter)
            .filter(notEmpty)
            .map((details: CorrespondenceLetter) => (
              <div className="correspondence-details__item">
                {CorrespondenceLetter.match({
                  PremiumNotice: premiumNoticeLetter => (
                    <PremiumNoticeLetter premiumNoticeLetter={premiumNoticeLetter} />
                  ),
                  AddressChangeForOwner: addressChangeLetter => (
                    <AddressChangeForOwnerLetter addressChangeForOwnerLetter={addressChangeLetter} />
                  ),
                  AutomaticPremiumLoanProvision: automaticPremiumLoanLetter => (
                    <AutomaticPremiumLoanProvision automaticPremiumLoanProvisionLetter={automaticPremiumLoanLetter} />
                  ),
                  FuturePurchaseOptions: futurePurchaseOptionsLetter => (
                    <FuturePurchaseOptions futurePurchaseOptionsLetter={futurePurchaseOptionsLetter} />
                  ),
                  InitialPremiumNotReceived: initialPremiumNotReceivedLetter => (
                    <InitialPremiumNotReceived initalPremiumNotReceivedLetter={initialPremiumNotReceivedLetter} />
                  ),
                  LoanPaidInFull: loanPaidInFullLetter => (
                    <LoanPaidInFull loadPaidInFullLetter={loanPaidInFullLetter} />
                  ),
                  PolicyLapse: policyLapseLetter => <PolicyLapse policyLapseLetter={policyLapseLetter} />,
                  PolicyLapseA: policyLapseALetter => <PolicyLapseA policyLapseALetter={policyLapseALetter} />,
                  PolicyPreLapse: policyPreLapse => <PolicyPreLapse policyPreLapseLetter={policyPreLapse} />,
                  PremiumChangeDueToExpiryOfSupplementBenefit: premiumChangeLetter => (
                    <PremiumChangeDueToExpiryOfSupplementalBenefit
                      premiumChangeDueToExpiryOfSupplementalBenefitLetter={premiumChangeLetter}
                    />
                  ),
                  PremiumPaidUp: premiumPaidUpLetter => <PremiumPaidUp premiumPaidUpLetter={premiumPaidUpLetter} />,
                  RenewableTermPolicyPremiumChange: renewableTermChangeLetter => (
                    <RenewableTermPremiumChange renewableTermPolicyPremiumChangeLetter={renewableTermChangeLetter} />
                  ),
                  RequestToCancel: requestToCancelLetter => (
                    <RequestToCancel requestToCancelLetter={requestToCancelLetter} />
                  ),
                  ReturnedPayment: returnedPaymentLetter => (
                    <ReturnedPaymentLetter returnedPaymentLetter={returnedPaymentLetter} />
                  ),
                  UniversalLifeGraceLetter: graceLetter => <GraceLetter graceLetter={graceLetter} />,
                  UniversalLifeGraceLetterAF: graceAFLetter => <GraceAFLetter graceAFLetter={graceAFLetter} />,
                  WithholdingFromLoanOrPartialWithdrawals: witholdingLetter => (
                    <WitholdingFromLoanLetter witholdingFromLoanLetter={witholdingLetter} />
                  ),
                  default: () => null as ReactNode,
                })(details)}
              </div>
            ))}
      </div>
      <Button color="primary" fullWidth onClick={onCloseDetails}>
        Close
      </Button>
    </Drawer>
  );
};

export default CorrespondenceDetails;
